import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DatosMaestrosService} from 'src/app/services/datos-maestros.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloConciliacionBan} from '../../../diccionarios/conciliacionBancariaModulo';
import {
  ParametroConciliacionBancariaPlusService
} from '../../../services/conciliacion-bancaria/parametro-conciliacion-bancaria-plus.service';

@Component({
  selector: 'app-sistema-conci-banca-plus',
  templateUrl: './sistema-conci-banca-plus.component.html',
  styleUrls: ['./sistema-conci-banca-plus.component.css']
})
export class SistemaConciliacionBancariaPlusComponent implements OnInit {
  formulario: FormGroup;
  result: String = '';
  result1: string = '';

  //combos
  cmbEmpresa: any[];
  cmbBanco: any[];
  // cmbCuenta: any[];

  DAT_MSG: any;
  DATA_BTNS: any;
  DAT_BTNCSS: any;

  habilitaCabec = true;
  habilitaDeta = true;

  validationCsv = true;
  responseValid: string;

  loading = false;
  loading2 = false;
  bloquearCampo = true;
  diccionarioModulo: any;


  constructor(
    private _paramConciBanca: ParametroConciliacionBancariaPlusService,
    private _utils: UtilsService,
    private _datosMaestros: DatosMaestrosService,
    public fb: FormBuilder
  ) {
    this.cargarEmpresa();
    // this.DAT_MSG = mensajes;
    // this.DATA_BTNS = buttons;
    this.diccionarioModulo = moduloConciliacionBan;
    this.DATA_BTNS = moduloConciliacionBan.button.buttonsNombre;
    this.DAT_MSG = moduloConciliacionBan.mensajes;
    this.DAT_BTNCSS = moduloConciliacionBan.button.buttonsCss;

    this.formulario = fb.group({
      idBanco: ['', [Validators.required]],
      idEmpresa: ['', [Validators.required]],
      cuenta: ['', [Validators.required]],
      fechaExtracto: ['', [Validators.required]],
      fileCab: [null, []],
      fileCuerp: [null, []]
    });
  }

  ngOnInit() {
  }


  onFileChange(event: any): void {
    const selectedFile = event.target.files[0];
    this.result = 'Nombre del archivo: ' + selectedFile.name;
    this.result += '<br>Tamaño del archivo(byte): ' + selectedFile.size;
    this.result += '<br>Tipo de archivo: ' + selectedFile.type;
  }

  onFileChange1(event: any): void {
    const selectedFile = event.target.files[0];
    this.result1 = 'Nombre del archivo: ' + selectedFile.name;
    this.result1 += '<br>Tamaño del archivo(byte): ' + selectedFile.size;
    this.result1 += '<br>Tipo de archivo: ' + selectedFile.type;
  }

  cargarEmpresa() {
    // this._paramConciBanca.getAllEmpresa().subscribe((resp) => {
    this._datosMaestros.getAllEmpresas().subscribe((resp) => {
      console.log(resp);
      this.cmbEmpresa = resp;
      console.log(this.cmbEmpresa);
    }, (error) => {
      this.cmbEmpresa = [];
      console.log(error);
    });
  }

  BancoEmpresa(target) {
    this.cargarBancoEmpresa(this.formulario.get('idEmpresa').value);
  }

  cargarBancoEmpresa(inIdEmpresa: string) {
    // this._paramConciBanca.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
    this._datosMaestros.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
      console.log(resp);
      this.cmbBanco = this.concatenarBancoId(resp);
    }, (error) => {
      this.cmbBanco = [];
      console.log(error);
    });
  }

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }

  cuentaBanco(target) {
    this.cargarCuentaBanco(this.formulario.get('idEmpresa').value, this.formulario.get('idBanco').value);
    this.cargarSelectorArchivo(this.formulario.get('idEmpresa').value, this.formulario.get('idBanco').value);
  }

  cargarCuentaBanco(inIdEmpresa, inIdBanco) {
    // this._paramConciBanca.getCuentaPorBanco(inIdEmpresa, inIdBanco).subscribe((resp) => {
    this._datosMaestros.getCuentaPorBanco(inIdEmpresa, inIdBanco).subscribe((resp) => {
      console.log(resp);
      //this.cmbCuenta = resp;
      this.formulario.get('cuenta').setValue(resp.cuentaBancaria);
    }, (error) => {
      this.formulario.get('cuenta').setValue('');
    });
  }

  cargarSelectorArchivo(inIdEmpresa, inIdBanco) {
    this._paramConciBanca.getSelectorArchivo(inIdEmpresa, inIdBanco).subscribe((resp: any) => {
      this.responseValid = resp;
      if (resp == 'SAP') {
        this.habilitaCabec = false;
        this.habilitaDeta = false;
        this.formulario.get('fileCab').setValue(null);
        this.formulario.get('fileCuerp').setValue(null);
      } else if (resp == 'Cuerpo') {
        this.habilitaCabec = true;
        this.habilitaDeta = false;
        this.formulario.get('fileCab').setValue(null);
        this.formulario.get('fileCuerp').setValue(null);
      }
      this.validacionDetalle();
    }, (error) => {
      this.habilitaCabec = true;
      this.habilitaDeta = true;
      this.formulario.get('fileCab').setValue(null);
      this.formulario.get('fileCuerp').setValue(null);
      console.log(error);
      this._utils.mensajeErrorVisto(error.error.mensaje);
    });
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (event.target.id == 'csvInputCab') {
        this.formulario.get('fileCab').setValue(file);
      } else {
        this.formulario.get('fileCuerp').setValue(file);
      }
    }
    console.log(this.formulario.value);
    this.validacionDetalle();
  }

  async onSubmit() {
    this.loading2 = true;
    const formData = new FormData();
    if (this.responseValid == 'SAP') {
      let data = this.formulario.value;
      let dataEnvio = await this.renderizarObjeto(data);
      // formData.append('file', this.formulario.get('fileCab').value);
      // formData.append('file', this.formulario.get('fileCuerp').value);
      formData.append('file', new Blob([this.formulario.get('fileCab').value], {type: 'text/csv'}), data.fileCab.name);
      formData.append('file', new Blob([this.formulario.get('fileCuerp').value], {type: 'text/csv'}), data.fileCuerp.name);
      formData.append('data', dataEnvio);
    } else if (this.responseValid == 'Cuerpo') {
      let data = this.formulario.value;
      formData.append('idEmpresa', this.formulario.get('idEmpresa').value);
      formData.append('idBanco', this.formulario.get('idBanco').value);
      formData.append('nCuenta', this.formulario.get('cuenta').value);
      // formData.append('file', this.formulario.get('fileCuerp').value);
      formData.append('file', new Blob([this.formulario.get('fileCuerp').value], {type: 'text/csv'}), data.fileCuerp.name);
      formData.append('fechaExtracto', this._utils.formatofecha(this.formulario.get('fechaExtracto').value));
    }
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.procesar,
        text: '',
        action: this.DATA_BTNS.procesar,//'Procesar',
        loading: true,
        context: this.BancoEmpresa,
        funcion: (this.responseValid == 'SAP') ? this._paramConciBanca.procesarArchivoSap(formData) : this._paramConciBanca.procesarArchivoCuerpo(formData)
      }
    ).then((response: any) => {
      // this.loading = false;
      this.loading2 = false;
      this.descargarArchivo(response);
    }).catch((err) => {
      this.loading = false;
      this.loading2 = false;
      // this.loading = false;
    });
  }

  async renderizarObjeto(data) {
    let dataEnvio: Object = {
      "idEmpresa": data.idEmpresa,
      "idBanco": data.idBanco,
      "numeroCuenta": data.cuenta,
      "fechaExtracto": this._utils.formatofecha(data.fechaExtracto)
    };
    return JSON.stringify(dataEnvio);
  }

  descargarArchivo(respuesta) {
    let name_file = respuesta.name;
    let archivo = respuesta.content;
    const dataURI = "data:aplication/plain;base64," + (archivo);
    var a = document.createElement("a");
    a.href = dataURI;
    a.setAttribute("download", name_file);
    a.click();
  }

  validacionDetalle() {
    this.validationCsv = true;
    const Comparacion = this.formulario.value;
    if (this.responseValid == 'SAP') {
      if (Comparacion.fileCab != null && Comparacion.fileCuerp != null) {
        this.validationCsv = false;
      }
    } else if (this.responseValid == 'Cuerpo') {
      if (Comparacion.fileCuerp != undefined) {
        this.validationCsv = false;
      }
    }
    return this.validationCsv;
  }

}
